export default "__VITE_ASSET__DvEkLQai__"